import React, {Component} from 'react'
import Link from 'gatsby-link'
import {Header} from '../components/Header'
import {Title} from '../components/Title'
import {FeaturedArticles} from '../components/FeaturedArticles'
import {SupportLetters} from '../components/SupportLetters'
import {VideoList} from '../components/VideoList'
import {ImageGallery} from '../components/ImageGallery'
import {LinkBox} from '../components/LinkBox'
import {Footer} from '../components/Footer'
import {Journals} from '../components/Journals'
import logoSrc from '../../static/logo_color.png'

import locale from '../locale'
import en from '../data-en'
import cn from '../data-cn'
let data = { en, cn };
let localizedData = () => data[locale.getLocale()];
let press_media_page = localizedData().press_media_page;

import './press-media.css'

class PressMediaPage extends Component {
  render() {

    let featuredArticlesSizes = [
      this.props.data.counterpartImage.sizes,
      this.props.data.youthImage.sizes,
      this.props.data.steinwayImage.sizes,
      this.props.data.chinaDailyImage.sizes,
      this.props.data.fromTheTopImage.sizes,
      this.props.data.wqxrImage.sizes,
    ];

    let supportLettersSizes = [
      this.props.data.cuomoImage.sizes,
      this.props.data.deBlasioImage.sizes,
      this.props.data.lockeImage.sizes,
      this.props.data.zhangImage.sizes
    ];

    return (
      <div>
        <Header src = {logoSrc} data={localizedData().header}></Header>
        <div className="margin-large">

          <FeaturedArticles
            data = {press_media_page.featured_articles}
            sizes = {featuredArticlesSizes}>
          </FeaturedArticles>

          <hr></hr>

          <Journals
            data = {press_media_page.journals}>
          </Journals>

          <hr></hr>

          <SupportLetters
            data = {press_media_page.support_letters}
            sizes = {supportLettersSizes}>
          </SupportLetters>

          <hr></hr>

          <VideoList data = {press_media_page.videos}></VideoList>

          <br></br>

          <LinkBox data = {press_media_page.link_to_videos}></LinkBox>

          <hr></hr>

          <ImageGallery
            data = {press_media_page.photo_gallery.photos}
            title = {press_media_page.photo_gallery.title}>
          </ImageGallery>

        </div>
        <Footer></Footer>
      </div>
    );
  }
}

export default PressMediaPage

export const pageQuery = graphql`
  query PressMediaQuery {
    cuomoImage: imageSharp(id: { regex: "/cuomo/" }) {
      sizes(maxWidth: 1000 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    deBlasioImage: imageSharp(id: { regex: "/de_blasio/" }) {
      sizes(maxWidth: 1000 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    lockeImage: imageSharp(id: { regex: "/locke/" }) {
      sizes(maxWidth: 1000 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    zhangImage: imageSharp(id: { regex: "/qiyue_zhang/" }) {
      sizes(maxWidth: 1000 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    youthImage: imageSharp(id: { regex: "/youth/" }) {
      sizes(maxWidth: 500 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    counterpartImage: imageSharp(id: { regex: "/counterpart/" }) {
      sizes(maxWidth: 500 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    steinwayImage: imageSharp(id: { regex: "/steinway/" }) {
      sizes(maxWidth: 1000 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    chinaDailyImage: imageSharp(id: { regex: "/china_daily/" }) {
      sizes(maxWidth: 1000 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    wqxrImage: imageSharp(id: { regex: "/wqxr/" }) {
      sizes(maxWidth: 500 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
    fromTheTopImage: imageSharp(id: { regex: "/from_the_top/" }) {
      sizes(maxWidth: 500 ) {
        ...GatsbyImageSharpSizes_noBase64
      }
    },
  }
`;



// WEBPACK FOOTER //
// ./src/pages/press-media.js